'use client'

import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import InputMask from 'react-input-mask';
import { useReCaptcha } from "next-recaptcha-v3";
import { fetchPostEmailSendContact, fetchGetCompanySubsidiaries } from "@/services/api";

export default function ContactUsContactForm({ company }) {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("contactSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendContact({
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            message: data.txtMessage,
            name: data.txtName,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtName', '');
                    setValue('txtEmail', '');
                    setValue('txtCellPhone', '');
                    setValue('txtMessage', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }

    const [subsidiaries, setSubsidiaries] = useState([])
    useEffect(() => {
        fetchGetCompanySubsidiaries()
            .then(res => {
                const subs = res.map(item => ({
                    city: item.addressCity,
                    federativeUnit: item.addressFederativeUnit,
                    postalCode: item.addressPostalCode,
                    address: item.addressStreet,
                    email: item.email,
                    phone: item.phone,
                    phone2: item.phone2,
                    whatsapp: item.whatsapp,
                    whatsapp2: item.whatsapp2
                }))
                setSubsidiaries(subs)
            })
    }, [])

    return (
        <section className="bg-white content-sm">
            <div className="auto-container">
                <div className="row">
                    <div className="col-md-12 theme-mb-20">
                        <p>Entre em contato com a <strong>Auto Porte Rio Preto Multimarcas</strong> - Preencha o formulário que retornamos seu contato!</p>
                    </div>
                    <div className="clearfix"></div>
                    <div className="col-md-8">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div className="form-group">
                                        <label>Nome: <span>*</span></label>
                                        <input type="text" className="form-control" placeholder="Nome Completo" {...register("txtName", { required: true })} required={errors.txtName} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group">
                                        <label>Email: <span>*</span></label>
                                        <input type="email" className="form-control" placeholder="Email" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group">
                                        <label>Telefone: <span>*</span></label>
                                        <InputMask type={'tel'} className="form-control" mask="(99) 99999-9999" maskChar=" " placeholder="Celular" {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div className="form-group">
                                        <label>Mensagem: <span>*</span></label>
                                        <textarea className="form-control" placeholder="Mensagem" rows="5" {...register("txtMessage", { required: true })} required={errors.txtMessage}></textarea>
                                    </div>
                                </div>
                                {
                                    formPost.isError
                                        ? <div className="col-md-12">
                                            <div class="alert alert-danger" role="alert">{formPost.errorText}</div>
                                        </div>
                                        : null
                                }
                                {
                                    formPost.isSuccess
                                        ? <div className="col-md-12">
                                            <div class="alert alert-success" role="alert">Contato enviado com sucesso, aguarde o retorno de nossa equipe!</div>
                                        </div>
                                        : null
                                }
                                <div className="col-md-12 mt-3">
                                    <button type="submit" disabled={formPost.isLoading} name="SendFormContato" value="SendFormContato" className="btn btn-lblue btn-arrow">
                                        <span> ENVIAR MENSAGEM<i className="mdi mdi-send"></i></span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-4 sidebar theme-pt-30">
                        <div className="row">
                            <div className="col-md-12 theme-mb-20">
                                <div className="site-heading text-left">
                                    <h2>{subsidiaries.length > 0 ? "Informações - Matriz" : "Informações"}</h2>
                                    <p></p>
                                </div>
                                <div className="clearfix"></div>
                                <ul className="list-unstyled contacts">
                                    <li>
                                        <i className="mdi mdi-phone-in-talk"></i>
                                        <a href={`tel:+55${company.phone}`} rel="nofollow" target="_blank" title={company.nickName}>
                                            {
                                                company.phone.length === 10
                                                    ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 6)}-${company.phone.substring(6, 10)}`
                                                    : company.phone.length === 11
                                                        ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 7)}-${company.phone.substring(7, 11)}`
                                                        : company.phone
                                            }
                                        </a>
                                    </li>
                                    {company.phone2 ?
                                        <li>
                                            <i className="mdi mdi-phone-in-talk"></i>
                                            <a href={`tel:+55${company.phone2}`} rel="nofollow" target="_blank" title={company.nickName}>
                                                {
                                                    company.phone2.length === 10
                                                        ? `(${company.phone2.substring(0, 2)}) ${company.phone2.substring(2, 6)}-${company.phone2.substring(6, 10)}`
                                                        : company.phone2.length === 11
                                                            ? `(${company.phone2.substring(0, 2)}) ${company.phone2.substring(2, 7)}-${company.phone2.substring(7, 11)}`
                                                            : company.phone2
                                                }
                                            </a>
                                        </li>
                                        : null}
                                    {company.whatsapp ?
                                        <li>
                                            <i className="mdi mdi-whatsapp"></i>
                                            <a href={`https://api.whatsapp.com/send?phone=55${company.whatsapp}&text=${company.whatsappDefaultMessage ? company.whatsappDefaultMessage : `Olá, gostaria de informações sobre a ${company.nickName}`}`} rel="nofollow" target="_blank" title={company.nickName}>
                                                {
                                                    company.whatsapp.length === 10
                                                        ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 6)}-${company.whatsapp.substring(6, 10)}`
                                                        : company.whatsapp.length === 11
                                                            ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 7)}-${company.whatsapp.substring(7, 11)}`
                                                            : company.whatsapp
                                                }
                                            </a>
                                        </li>
                                    : null}
                                    {company.whatsapp2 ?
                                        <li>
                                            <i className="mdi mdi-whatsapp"></i>
                                            <a href={`https://api.whatsapp.com/send?phone=55${company.whatsapp2}&text=${company.whatsappDefaultMessage ? company.whatsappDefaultMessage : `Olá, gostaria de informações sobre a ${company.nickName}`}`} rel="nofollow" target="_blank" title={company.nickName}>
                                                {
                                                    company.whatsapp2.length === 10
                                                        ? `(${company.whatsapp2.substring(0, 2)}) ${company.whatsapp2.substring(2, 6)}-${company.whatsapp2.substring(6, 10)}`
                                                        : company.whatsapp2.length === 11
                                                            ? `(${company.whatsapp2.substring(0, 2)}) ${company.whatsapp2.substring(2, 7)}-${company.whatsapp2.substring(7, 11)}`
                                                            : company.whatsapp2
                                                }
                                            </a>
                                        </li>
                                    : null}                                    
                                    <li>
                                        <i className="mdi mdi-email"></i>
                                        <a href={`mailto:${company.email}`} title={company.nickName}>
                                            {company.email}
                                        </a>
                                    </li>
                                </ul>
                                 {subsidiaries.length > 0 ?
                                    subsidiaries.map((item, index) => (

                                        <div key={index}>
                                            <div className="site-heading text-left">
                                                <h2>Informações - Filial</h2>
                                                <p></p>
                                            </div>
                                            <div className="clearfix"></div>
                                            <ul className="list-unstyled contacts">
                                                <li>
                                                    <i className="mdi mdi-phone-in-talk"></i>
                                                    <a href={`tel:+55${item.phone}`} rel="nofollow" target="_blank" title={item.nickName}>
                                                        {
                                                            item.phone.length === 10
                                                                ? `(${item.phone.substring(0, 2)}) ${item.phone.substring(2, 6)}-${item.phone.substring(6, 10)}`
                                                                : item.phone.length === 11
                                                                    ? `(${item.phone.substring(0, 2)}) ${item.phone.substring(2, 7)}-${item.phone.substring(7, 11)}`
                                                                    : item.phone
                                                        }
                                                    </a>
                                                </li>
                                                {item.phone2 ?
                                                    <li>
                                                        <i className="mdi mdi-phone-in-talk"></i>
                                                        <a href={`tel:+55${item.phone2}`} rel="nofollow" target="_blank" title={item.nickName}>
                                                            {
                                                                item.phone2.length === 10
                                                                    ? `(${item.phone2.substring(0, 2)}) ${item.phone2.substring(2, 6)}-${item.phone2.substring(6, 10)}`
                                                                    : item.phone2.length === 11
                                                                        ? `(${item.phone2.substring(0, 2)}) ${item.phone2.substring(2, 7)}-${item.phone2.substring(7, 11)}`
                                                                        : item.phone2
                                                            }
                                                        </a>
                                                    </li>
                                                    : null
                                                }
                                                <li>
                                                    <i className="mdi mdi-whatsapp"></i>
                                                    <a href={`https://api.whatsapp.com/send?phone=55${item.whatsapp}&text=${company.whatsappDefaultMessage? company.whatsappDefaultMessage : "Olá, gostaria de informações sobre a loja"}`} rel="nofollow" target="_blank" title={item.nickName}>
                                                        {
                                                            item.whatsapp.length === 10
                                                                ? `(${item.whatsapp.substring(0, 2)}) ${item.whatsapp.substring(2, 6)}-${item.whatsapp.substring(6, 10)}`
                                                                : item.whatsapp.length === 11
                                                                    ? `(${item.whatsapp.substring(0, 2)}) ${item.whatsapp.substring(2, 7)}-${item.whatsapp.substring(7, 11)}`
                                                                    : item.whatsapp
                                                        }
                                                    </a>
                                                </li>
                                                {item.whatsapp2 ?
                                                    <li>
                                                        <i className="mdi mdi-whatsapp"></i>
                                                        <a href={`https://api.whatsapp.com/send?phone=55${item.whatsapp2}&text=${company.whatsappDefaultMessage? company.whatsappDefaultMessage : "Olá, gostaria de informações sobre a loja"}`} rel="nofollow" target="_blank" title={item.nickName}>
                                                            {
                                                                item.whatsapp2.length === 10
                                                                    ? `(${item.whatsapp2.substring(0, 2)}) ${item.whatsapp2.substring(2, 6)}-${item.whatsapp2.substring(6, 10)}`
                                                                    : item.whatsapp2.length === 11
                                                                        ? `(${item.whatsapp2.substring(0, 2)}) ${item.whatsapp2.substring(2, 7)}-${item.whatsapp2.substring(7, 11)}`
                                                                        : item.whatsapp2
                                                            }
                                                        </a>
                                                    </li>
                                                    : null}
                                                <li>
                                                    <i className="mdi mdi-email"></i>
                                                    <a href={`mailto:${item.email}`} title={item.nickName}>
                                                        {item.email}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ))

                                    : null
                                }
                                <div className="clearfix w-100 d-block theme-mb-30"></div>
                                <div className="site-heading text-left">
                                    <h2>Redes Sociais</h2>
                                    <p></p>
                                </div>
                                <div className="clearfix"></div>
                                <ul className="social-icons color-hover">
                                    {
                                        company.facebook
                                            ? <li className="social-facebook">
                                                <a href={company.facebook} rel="nofollow" target="_blank" title={company.nickName}>
                                                    <i className="mdi mdi-facebook"></i>
                                                </a>
                                            </li>
                                            : null
                                    }
                                    {
                                        company.instagram
                                            ? <li className="social-instagram">
                                                <a href={company.instagram} rel="nofollow" target="_blank" title={company.nickName}>
                                                    <i className="mdi mdi-instagram"></i>
                                                </a>
                                            </li>
                                            : null
                                    }
                                    {
                                        company.youtube
                                            ? <li className="social-youtube">
                                                <a href={company.youtube} rel="nofollow" target="_blank" title={company.nickName}>
                                                    <i className="mdi mdi-youtube"></i>
                                                </a>
                                            </li>
                                            : null
                                    }
                                    {
                                        company.tiktok
                                            ? <li className="social-tiktok">
                                                <a href={company.tiktok} rel="nofollow" target="_blank" title={company.nickName}>
                                                    <i className="fa-brands fa-tiktok"></i>
                                                </a>
                                            </li>
                                            : null
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}